<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-row>
            <el-form-item label="设备分组">
              <el-select
                v-model="equipmentCode"
                style="float: left"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in lightEquipmentList"
                  :key="item.id"
                  :label="item.equipmentName"
                  :value="item.equipmentCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="统计时间" prop="date">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 60rem; float: left"
                unlink-panels
                :clearable="false"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label style="float: right">
              <el-button @click="onSearch">搜 索</el-button>
              <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
          </el-row>
        </el-form>

        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main
        style="padding-top: 0; overflow-y: auto"
        :loading="loading"
      >
        <div class="detail-header">
          <span class="header-title">能耗曲线</span>
          <div class="arrow-pic"></div>
        </div>
        <div class="config-header" style="height: 100%">
          <div class="config-content" style="height: 100%">
            <div class="analysis_chart">
              <div style="width: 100%; height: 100%">
                <LineEchart3
                  title=""
                  xAxisName="日期"
                  yAxisName="KWH"
                  :chartData="analysisData"
                ></LineEchart3>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import {
  getEquipmentCode,
  listEquipment,
  listAggregationDay,
} from "@/api/src/equipment";

export default {
  name: "LightStatistics",
  componentName: "LightStatistics",

  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      loading: false,

      //预警日志
      logList: [],
      //设备信息
      lightEquipmentList: [],
      date: [
        new Date(new Date() - 7 * 24 * 60 * 60 * 1000),
        new Date(new Date() - 1 * 24 * 60 * 60 * 1000),
      ],
      analysisData: {
        days: [],
        data: [],
      },
      code: null,
      equipmentCode: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date().getTime() - 3600 * 1000 * 24;
        },
      },
    };
  },
  methods: {
    // 获取设备code
    init() {
      getEquipmentCode("lightEquipment").then((response) => {
        this.code = response.data;
        this.getList();
      });
    },
    // 查询
    getList() {
      this.loading = true;

      listEquipment({ categoryCode: this.code, pageSize: 10000 })
        .then((response) => {
          this.lightEquipmentList = response.rows;
          this.onSearch();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onSearch() {
      this.loading = true;
      const searchInfo = {
        equipmentCode: this.equipmentCode,
        startTs:
          this.date == null ? "0001-01-01T00:00:00" : this.date[0].getTime(),
        endTs:
          this.date == null ? "0001-01-01T00:00:00" : this.date[1].getTime(),
        pageSize: 10000,
        categoryCode: this.code,
        countType: "有功电度",
      };

      listAggregationDay(searchInfo)
        .then((response) => {
          let days = [],
            data = [];

          response.data.forEach((item) => {
            days.push(item.statDay);
            data.push(item.statCount.toFixed(2));
          });
          this.analysisData = { days: days, data: data };

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onCancel() {
      this.equipmentCode = null;
      this.date = [
        new Date(new Date() - 8 * 24 * 60 * 60 * 1000),
        new Date(new Date() - 1 * 24 * 60 * 60 * 1000),
      ];
      this.onSearch();
    },
  },
  mounted() {
    this.init();
    this.logInfo.ActionName = "灌溉统计";
    this.logInfo.LogMessage = "灌溉统计";
    this.logInfo.ModuleName = "智能控制";
    this.logInfo.PageName = "灌溉统计";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "UI",
  action: "LightStatistics",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
